import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "aside-logo flex-column-auto border-bottom",
  id: "kt_aside_logo"
}
const _hoisted_2 = { href: "#" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  alt: "Logo",
  src: "/media/avatars/blank.png",
  class: "h-50px logo"
}
const _hoisted_5 = {
  id: "kt_aside_toggle",
  class: "btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle",
  "data-kt-toggle": "true",
  "data-kt-toggle-state": "active",
  "data-kt-toggle-target": "body",
  "data-kt-toggle-name": "aside-minimize"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1 rotate-180" }
const _hoisted_7 = { class: "aside-menu flex-column-fluid" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "aside-footer flex-column-auto pt-5 pb-7 px-5 text-center",
  id: "kt_aside_footer"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.obea.fr/",
    target: "_blank",
    class: "mt-12"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo",
      src: "/media/logo_obea.svg",
      class: "h-45px"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside aside-hoverable", [_ctx.asideTheme === 'light' && 'aside-light', _ctx.asideTheme === 'dark' && 'aside-dark']]),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, [
        (this.$store.getters.currentSettings && this.$store.getters.currentSettings.clientLogo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              alt: "Logo",
              src: this.$store.getters.currentSettings.clientLogo,
              class: "w-100 logo"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr080.svg" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_KTMenu)
    ]),
    _hoisted_8
  ], 2))
}